import { getScopedLocalStorageValue, setScopedLocalStorageValue } from "../../utils/scopedLocalStorage"

const recentEmojisKey = "@oktto:chatRecentEmojis"
const recentEmojisUpdatedEvent = "oktto_chat_recent_emojis_updated"
const recentEmojisLimit = 30

const getRecentEmojiIcons = (accountId, userId) => {
    try {
        const legacyValue = window.localStorage.getItem(recentEmojisKey)
        const value = JSON.parse(getScopedLocalStorageValue(recentEmojisKey, accountId, userId, legacyValue, true) || "[]")
        return Array.isArray(value) ? value.filter(Boolean).slice(0, recentEmojisLimit) : []
    } catch {
        return []
    }
}

const saveRecentEmojiIcons = (icons, accountId, userId) => {
    try {
        setScopedLocalStorageValue(recentEmojisKey, accountId, userId, JSON.stringify(icons.slice(0, recentEmojisLimit)))
    } catch { }
}

const getGraphemes = (text = "") => {
    if (typeof Intl !== "undefined" && Intl.Segmenter) {
        return [...new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(text)].map(item => item.segment)
    }

    return Array.from(text)
}

const isEmoji = (value = "") => {
    return /\p{Extended_Pictographic}/u.test(value)
}

const addRecentEmojisByText = (text = "", accountId, userId) => {
    if (!text) return

    const usedIcons = getGraphemes(text)
        .filter(isEmoji)
        .reverse()
        .filter((icon, index, list) => list.indexOf(icon) === index)

    if (!usedIcons.length) return

    const currentIcons = getRecentEmojiIcons(accountId, userId)
    const nextIcons = [
        ...usedIcons,
        ...currentIcons.filter(icon => !usedIcons.includes(icon))
    ].slice(0, recentEmojisLimit)

    saveRecentEmojiIcons(nextIcons, accountId, userId)
    window.dispatchEvent(new Event(recentEmojisUpdatedEvent))
}

export {
    addRecentEmojisByText,
    getRecentEmojiIcons,
    recentEmojisUpdatedEvent,
}
